import React, { useState, useEffect } from 'react'
import {
    Box, Paper, makeStyles, Typography, 
    Avatar, Badge, Chip
} from '@material-ui/core';
import {
    Notifications as NotificationsIcon,
    FilterList as FilterIcon,
} from '@material-ui/icons';
import ProfileUpdateInfo from '../../components/ProfileUpdateInfo/ProfileUpdateInfo'
import { useDispatch, useSelector } from 'react-redux';
import * as actions from "../../store/action";
import moment from 'moment';
import Pagination from '@material-ui/lab/Pagination';

const useStyle = makeStyles((theme) => ({
    header: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        paddingBottom: theme.spacing(2),
    },
    title: {
        display: 'flex',
        alignItems: 'center',
        fontWeight: 600,
        // color: theme.palette.primary.main,
        '& svg': {
            marginRight: theme.spacing(1.5),
            fontSize: '2rem',
        }
    },
    filterSection: {
        display: 'flex',
        alignItems: 'center',
    },
    filterChip: {
        marginRight: theme.spacing(1),
        '&:hover':{
            color:theme.palette.primary.contrastText
        }
    },
    notificationBox: {
        cursor: 'pointer',
        width: "100%",
        // padding: theme.spacing(2),
        display: "flex",
        justifyContent: "space-between",
        marginBottom: theme.spacing(2),
        position: "relative",
        overflow: "hidden",
        transition: 'all 0.3s ease',
        borderRadius: 12,
        '&:hover': {
            transform: 'translateY(-2px)',
            boxShadow: theme.shadows[4],
        },
        '&::after': {
            content: `""`,
            position: "absolute",
            left: 0,
            top: 0,
            width: 4,
            height: "100%",
            background: theme.palette.primary.main,
            borderRadius: '4px 0 0 4px',
        }
    },
    unreadNotification: {
        background: 'rgba(24, 74, 123, 0.05)',
        '&::after': {
            background: theme.palette.secondary.main,
        }
    },
    notificationContent: {
        display: 'flex',
        alignItems: 'center',
        flex: 1,
    },
    notificationIcon: {
        marginRight: theme.spacing(2),
        background: theme.palette.primary.light,
        color: theme.palette.primary.contrastText,
    },
    menuDesc: {
        fontSize: 14,
        color: "rgba(0, 0, 0, 0.6)",
        lineHeight: 1.4,
        '&.isRead': {
            fontWeight: "500",
            color: "#000"
        }
    },
    notificationTime: {
        fontSize: 12,
        color: theme.palette.text.secondary,
        minWidth: 70,
        textAlign: 'right',
    },
    paginationContainer: {
        display: 'flex',
        justifyContent: 'center',
        marginTop: theme.spacing(4),
    },
    emptyState: {
        textAlign: 'center',
        padding: theme.spacing(6),
        color: theme.palette.text.secondary,
    },
    emptyIcon: {
        fontSize: '4rem',
        marginBottom: theme.spacing(2),
        color: theme.palette.grey[400],
    },
}));

const Notification = () => {
    const dispatch = useDispatch();
    const classes = useStyle();
    const { notificationList } = useSelector((state) => state.notification)
    const [page, setPage] = React.useState(1);
    const [filter, setFilter] = useState('all'); // 'all', 'unread', 'read'

    useEffect(() => {
        getNotificationAction(page)
    }, [])

    const readNotification = (e, val) => {
        e.preventDefault();
        const requestData = {
            notification_id: val.id,
            is_read: true,
            signee_id: val.signee_id
        }
        dispatch(actions.readNotification(requestData, page))
    }

    const getNotificationAction = (value) => {
        dispatch(actions.getNotification(value))
    }

    const handleChangePage = (event, value) => {
        setPage(value);
        setTimeout(getNotificationAction(value), 2000);
    }

    const filteredNotifications = notificationList?.data ? 
        notificationList.data.filter(notification => {
            if (filter === 'all') return true;
            if (filter === 'unread') return notification.is_read === 0;
            if (filter === 'read') return notification.is_read === 1;
            return true;
        }) : [];

    return (
        <>
            <ProfileUpdateInfo />

            <Box className={classes.header}>
                <Typography variant="h4" className={classes.title}>
                    <NotificationsIcon />
                    Notifications
                </Typography>
                <Box className={classes.filterSection}>
                    <FilterIcon style={{marginRight: 8}} />
                    <Chip 
                        label="All" 
                        onClick={() => setFilter('all')} 
                        color={filter === 'all' ? 'primary' : 'default'}
                        className={classes.filterChip}
                    />
                    <Chip 
                        label="Unread" 
                        onClick={() => setFilter('unread')} 
                        color={filter === 'unread' ? 'secondary' : 'default'}
                        className={classes.filterChip}
                    />
                    <Chip 
                        label="Read" 
                        onClick={() => setFilter('read')} 
                        color={filter === 'read' ? 'default' : 'default'}
                        className={classes.filterChip}
                    />
                </Box>
            </Box>

            

            <Box>
                {filteredNotifications.length > 0 ? (
                    filteredNotifications.map((val, index) => {
                        return (
                            <Paper 
                                key={index} 
                                elevation={val.is_read == 0 ? 2 : 1} 
                                onClick={(e) => readNotification(e, val)} 
                                className={`${classes.notificationBox} ${val.is_read == 0 ? classes.unreadNotification : ''}`}
                            >
                                <Box className={classes.notificationContent}>
                                    <Badge color="secondary" variant="dot" invisible={val.is_read == 1}>
                                        <Avatar className={classes.notificationIcon}>
                                            <NotificationsIcon fontSize="small" />
                                        </Avatar>
                                    </Badge>
                                    <Box>
                                        <Typography variant="body2" className={`${classes.menuDesc} ${val.is_read == 0 ? 'isRead' : ''}`}>
                                            {val.message}
                                        </Typography>
                                    </Box>
                                </Box>
                                <Typography variant="caption" className={classes.notificationTime}>
                                    {moment(val.created_at).format('MMM DD')}
                                    <br />
                                    {moment(val.created_at).format('HH:mm')}
                                </Typography>
                            </Paper>
                        )
                    })
                ) : (
                    <Box className={classes.emptyState}>
                        <NotificationsIcon className={classes.emptyIcon} />
                        <Typography variant="h6" color="textSecondary">
                            No notifications found
                        </Typography>
                        <Typography variant="body2">
                            {filter !== 'all' ? 
                                `You don't have any ${filter} notifications` : 
                                "You're all caught up! New notifications will appear here."
                            }
                        </Typography>
                    </Box>
                )}
            </Box>

            {notificationList?.last_page > 1 && (
                <Box className={classes.paginationContainer}>
                    <Pagination 
                        onChange={handleChangePage} 
                        page={page} 
                        count={notificationList?.last_page} 
                        color="primary"
                        shape="rounded" 
                    />
                </Box>
            )}
        </>
    )
}

export default Notification